// extracted by mini-css-extract-plugin
module.exports = {"label":"ChangePersonDialog_label__1BVRY","flexGrow1":"ChangePersonDialog_flexGrow1__2ISPO"};